export default __webpack_public_path__ + "static/media/life-made-better.c5c8cb90.svg";